export default {
  namespaced: true,
  state: {
    all: [],
    loading: false
  },
  getters: {
    all: state => state.all,
    find: state => id => state.all.find(experience => experience.id == id),
    loading: state => state.loading
  },
  mutations: {
    startLoading(state) {
      state.loading = true
    },
    stopLoading(state) {
      state.loading = false
    },
    setAll(state, experiences) {
      state.all = experiences.map(exp => Object.assign(exp, { loading: false }))
      state.loading = false
    },
    set(state, experience) {
      state.all = state.all.filter(o => o.id != experience.id)
      state.all.push(experience)
    },
    remove(state, id) {
      state.all = state.all.filter(o => o.id != id)
    }
  },
  actions: {
    fetchAll({ commit }) {
      commit('startLoading')
      return Vue.$http
        .get('candidate/experiences')
        .then(response => commit('setAll', response.data), response => commit('stopLoading'))
    },
    create({ commit }, experience) {
      return Vue.$http
        .post('candidate/experiences', { experience })
        .then(response => commit('set', Object.assign(response.data, { loading: false })))
    },
    destroy({ commit, getters }, id) {
      const experience = getters.find(id)

      if (experience) {
        commit('set', Object.assign(experience, { loading: true }))
      } else {
        commit('set', { id, loading: true })
      }

      return Vue.$http
        .delete(`candidate/experiences/${id}`)
        .then(
          response => commit('remove', id),
          response => commit('set', Object.assign(experience, { loading: false }))
        )
    },
    update({ commit, dispatch }, experience) {
      return Vue.$http.patch(`candidate/experiences/${experience.id}`, { experience }).then(
        response => {
          if (response.data.errors) {
            commit(
              'snackbar',
              {
                text: 'There was a problem updating the work experience',
                type: 'error'
              },
              { root: true }
            )
            commit('set', Object.assign(experience, response.body))
          } else {
            commit(
              'snackbar',
              {
                text: 'Work experience was updated successfully',
                type: 'success'
              },
              { root: true }
            )
            dispatch('fetchAll', { profile: experience.profile })
          }
        },
        response =>
          commit(
            'snackbar',
            {
              text: 'There was a problem updating the work experience',
              type: 'error'
            },
            { root: true }
          )
      )
    }
  }
}
